import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Building2, Users, FileText, LayoutDashboard } from 'lucide-react';

export default function AdminDashboard() {
  return (
    <div className="min-h-screen bg-muted/30">
      <div className="border-b bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Admin Dashboard</h1>
            <Link to="/">
              <Button variant="outline">Back to Site</Button>
            </Link>
          </div>
        </div>
      </div>
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Link to="/admin/companies">
            <Card className="rounded-xl hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <Building2 className="h-10 w-10 mb-2" style={{ color: 'var(--ap-blue)' }} />
                <CardTitle>Portfolio Companies</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">Manage portfolio companies, KPIs, and metrics</p>
              </CardContent>
            </Card>
          </Link>
          
          <Link to="/admin/leads">
            <Card className="rounded-xl hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <Users className="h-10 w-10 mb-2" style={{ color: 'var(--ap-blue)' }} />
                <CardTitle>Leads</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">View and manage leads from assessments and contact form</p>
              </CardContent>
            </Card>
          </Link>
          
          <Link to="/admin/resources">
            <Card className="rounded-xl hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <FileText className="h-10 w-10 mb-2" style={{ color: 'var(--ap-blue)' }} />
                <CardTitle>Resources</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">Manage playbooks and case studies</p>
              </CardContent>
            </Card>
          </Link>
        </div>
        
        <div className="mt-8">
          <Card className="rounded-xl">
            <CardHeader>
              <CardTitle>Quick Stats</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Total Companies</p>
                  <p className="text-2xl font-semibold">-</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Active Leads</p>
                  <p className="text-2xl font-semibold">-</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Published Resources</p>
                  <p className="text-2xl font-semibold">-</p>
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">Assessments</p>
                  <p className="text-2xl font-semibold">-</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
    </div>
  );
}